/**
 * Zod schemas for Form Input plugin - field definitions, form configuration, and submitted form values.
 */
import { z } from "zod";
/**
 * Field definition for form inputs.
 */
export const formFieldSchema = z.object({
    name: z.string().min(1, "Field name is required"),
    label: z.string().min(1, "Field label is required"),
    type: z.enum(["text", "textarea", "select", "checkbox", "radio", "number", "date"]),
    required: z.boolean().default(false),
    options: z.array(z.string()).optional(),
    placeholder: z.string().optional(),
    defaultValue: z.union([z.string(), z.number(), z.boolean()]).optional(),
});
/**
 * Configuration schema for the form input step type.
 */
export const configSchema = z.object({
    fields: z.array(formFieldSchema),
    submitLabel: z.string().default("Submit"),
});
/**
 * Data schema for form input step execution.
 */
export const dataSchema = z.object({
    formValues: z.record(z.unknown()),
});
/**
 * Default configuration for new form input steps.
 */
export const defaultConfig = {
    fields: [],
    submitLabel: "Submit",
};
//# sourceMappingURL=schema.js.map